
document.addEventListener('DOMContentLoaded', () => {
  class LinkProducts extends HTMLElement {
    static blocksToUpdate = ['media-gallery', 'product-info', 'product-sticky-form'];      
    constructor() {
      super();
      this.buttons = [...this.querySelectorAll('.button-redirect')];
      this.sectionId = this.getAttribute('data-section-id');
      this.shopifySection = this.closest('.shopify-section');
      
      if (!this.sectionId) {
        console.warn('Missing data-section-id attribute');
        return;
      }
      
      this.initializeEventListeners();
    }

    initializeEventListeners() {
      this.buttons.forEach(button => button.addEventListener('click', this.handleClick.bind(this)));
    }

    handleClick = async (event) => {
      const { currentTarget: { dataset: { href: url } } } = event;    
      
      if (!url) {
        console.error('Missing data-href attribute');
        return;
      }

      try {
        const fetchUrl = `${url}?${this.sectionId}`;
        const targetHtmlDocument = await this.fetchDocument(fetchUrl);
        
        this.updateSectionContent(targetHtmlDocument);
        window.history.pushState({}, '', url);

      } catch (error) {

        console.log(error);
        
        window.location.href = url;
      }
    }

    async fetchDocument(url) {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    }

    updateSectionContent(newHtmlDocument) {
      LinkProducts.blocksToUpdate.forEach(selector => {
          const currentElements = this.shopifySection.querySelectorAll(selector);
          const newElement = newHtmlDocument.querySelector(selector);
  
          if (!newElement) {
              console.warn(`Element ${selector} not found in response`);
              return;
          }
  
          if (selector === 'product-info') {
              const linkProductsElement = newElement.querySelector("link-products");
              const legendLabelNew = linkProductsElement.querySelector("legend.form__label");
              const legendLabelOld = this.querySelector("legend.form__label");
                              
              const newActiveInput = linkProductsElement 
                  ? [...linkProductsElement.querySelectorAll('input[type="radio"]')]
                      .find(input => input.hasAttribute('checked'))
                  : null;
  
              if (newActiveInput) {
                  const activeIdProduct = newActiveInput.dataset.id;
                  
                  this.querySelectorAll('input[type="radio"]').forEach(input => {
                      input.checked = false;
                  });
                  
                  const targetInput = this.querySelector(`input[data-id="${activeIdProduct}"]`);
                  if (targetInput) {
                      targetInput.checked = true;
                  } else {
                      console.warn(`Input with data-id ${activeIdProduct} not found`);
                  }
              }
              if (legendLabelNew && legendLabelOld) {
                legendLabelOld.innerHTML = "";
                legendLabelOld.innerHTML = legendLabelNew.innerHTML;
              }
  
              if (linkProductsElement) {
                  linkProductsElement.replaceWith(this.cloneNode(true));
              }
          }
  
          currentElements.forEach((element, index) => {
              const elementToReplace = newElement.cloneNode(true);
              element.replaceWith(elementToReplace);
          });
      });
  }
  }

  customElements.define('link-products', LinkProducts);
});